import React from 'react'

export const FilterItemLayout = ({ children }) => <React.Fragment>{children}</React.Fragment>



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/FilterItem/layout.js